module.exports = __webpack_public_path__ + "img/dislike.7815556f.svg";